var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackdownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7741 -2.25017e-07L15 1.48725L8.31881 9.58796C8.21176 9.71854 8.08445 9.82216 7.94422 9.89288C7.804 9.9636 7.65362 10 7.50174 10C7.34985 10 7.19947 9.9636 7.05925 9.89288C6.91902 9.82216 6.79171 9.71854 6.68466 9.58796L3.07467e-07 1.48725L1.22591 0.00140101L7.5 7.60448L13.7741 -2.25017e-07Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackdownarrow);
export default __webpack_public_path__ + "static/media/blackdownarrow.107f482020671bc9b68ee188ebaf9145.svg";
export { ForwardRef as ReactComponent };